package com.exura.features.plandefinition.domain.model.element

import com.exura.features.firebase.domain.model.SerializableDomainModel
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Represents a concrete instance of a series pattern, anchored to a specific date.
 * These elements are what will be displayed to users in the navigation interface.
 * Updated to implement SerializableDomainModel for Firebase storage.
 */
abstract class BasePlanElement(
    override val firebaseDocId: String?,
    override val firebaseDocPrefix: CollectionReference?,
    val elementType: ElementType,
) : SerializableDomainModel {
    abstract val imageUrl: String?
    abstract val durationInMinutes: Int
    abstract val relativeDay: Int?
    abstract val title: String

    /**
     * Returns the duration of this element in days
     */
    abstract fun durationInDays(): Int
}
